{
  "asIssue": "Als Issue eröffnen (erste Zeile ist der Titel)",
  "issueActions": {"reopen": "Wieder öffnen", "resolve": "Als gelöst markieren"},
  "issueReasons": {"reopen": "Wieder geöffnet.", "resolve": "Gelöst."},
  "issueStates": {"open": "Offen", "resolved": "Gelöst"},
  "issuesTitle": "Issues",
  "noIssues": "Noch keine Issues.",
  "openIssue": "Issue eröffnen",
  "openedBy": "Eröffnet von {{name}}",
  "placeholder": "Kommentar schreiben (Markdown)",
  "replyPlaceholder": "Auf dieses Issue antworten",
  "send": "Kommentieren",
  "termTitle": "Kommentare und Issues zu diesem Begriff",
  "title": "Kommentare und Issues"
}
